module.exports = function frontEndTagging() {
    const createFrontEndLabel = (tag, identifier) => {
      const labelContainer = document.createElement('p');
      const labelText = document.createTextNode(tag);
      labelContainer.appendChild(labelText);
      labelContainer.classList.add(identifier);
      labelContainer.classList.add('ob-custom-label');
      return labelContainer;
    };
  
    const appendFrontEndLabel = (tile, label) => {
      const description = tile.querySelector('.description');
      const firstChild = description.firstElementChild;
      if (!description.querySelector('.ob-custom-label')) {
        description.insertBefore(label, firstChild);
      }
    };
  
    const applyFrontEndTags = (taggedTiles, frontEndLabels) => {
      taggedTiles.forEach((tile) => {
        for (const tag in frontEndLabels) {
          const normalizedTags = tile.dataset.tags
            .toLowerCase()
            .split(' ')
            .join('');
          const regEx = new RegExp(tag, 'gi');
          if (regEx.test(normalizedTags)) {
            const frontEndLabel = createFrontEndLabel(frontEndLabels[tag], tag);
            appendFrontEndLabel(tile, frontEndLabel);
          }
        }
      });
    };
  
    const getTags = () => {
      const frontEndLabels = window.obData.frontEndTags;
      const tiles = [...document.querySelectorAll('.tile.single:not(.cta):not(.loading-notifier)')];
      const taggedTiles = tiles.filter((tile) => tile.dataset.tags);
      console.log(frontEndLabels);
      applyFrontEndTags(taggedTiles, frontEndLabels);
    };
  
    getTags();
  };


// WEBPACK FOOTER //
// ./scriptPartials/tagging.js